interface PhoneMockupProps {
  children: React.ReactNode;
}

export default function PhoneMockup({ children }: PhoneMockupProps) {
  return (
    <>
      {/* Desktop: iPhone-style bezel — ~9:19.5 aspect ratio */}
      <div className="hidden md:block">
        <div
          className="relative border-[3px] border-gray-800 dark:border-gray-600 rounded-[32px] shadow-2xl bg-white dark:bg-gray-900 overflow-hidden mx-auto"
          style={{ width: 280 }}
        >
          {/* Dynamic Island pill */}
          <div className="flex justify-center pt-2 pb-1 bg-white dark:bg-gray-900">
            <div className="w-20 h-[18px] bg-gray-800 dark:bg-gray-600 rounded-full" />
          </div>
          {/* Content area — tall to match iPhone proportions */}
          <div className="overflow-y-auto flex flex-col" style={{ height: 540 }}>
            {children}
          </div>
          {/* Home indicator */}
          <div className="flex justify-center py-2 bg-white dark:bg-gray-900">
            <div className="w-24 h-1 bg-gray-300 dark:bg-gray-600 rounded-full" />
          </div>
        </div>
      </div>

      {/* Mobile: render children directly */}
      <div className="md:hidden">{children}</div>
    </>
  );
}
